export default __webpack_public_path__ + "static/media/close.4b3fbba8.svg";